import type {
  ELanguage,
} from '@qmulus/frontend-shared/type/locale.ts';
import type {
  TColorTheme,
  TDensity,
} from '@qmulus/ui/utils/appearance.ts';

import {
  DEFAULT_CHART_TIME_FORMAT,
} from '@/components/select-chart-time-format/select-chart-time-format.ts';
import {
  DEFAULT_FONT_SIZE,
} from '@/types/font-size.ts';
import {
  EScaleOption,
} from '@/types/scale.ts';
import type {
  ICustomUserSettings,
} from '@/utils/custom-storage/custom-user-settings.ts';

/**
 * The user settings applied when nothing is stored for the user. The default locale depends on the
 * browser and the default appearance is defined in SCSS, so both are passed in. This keeps the module
 * usable outside of the browser, e.g. by the screenshot capture, whose Node runtime cannot load SCSS.
 */
export function createDefaultUserSettings({
  locale,
  colorTheme,
  density,
}: {
  locale: ELanguage,
  colorTheme: TColorTheme,
  density: TDensity,
}): ICustomUserSettings {
  return {
    locale,
    fontSize: DEFAULT_FONT_SIZE,
    colorTheme,
    density,
    chartTimeFormat: DEFAULT_CHART_TIME_FORMAT,
    unitSystem: 'metric',
    scaleOption: EScaleOption.FULL_SIZE,
    alarmsNotification: false,
    showOnlyAvailableApps: true,
    hasOptedOutOfReleaseHighlights: false,
  };
}
